export default function() {
  return /^(19[2-9][0-9]|200[0-9])[\-\.]([1-9]|0[1-9]|10|11|12|)[\-\.]([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-2])$/;
};